// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"CopyIconButton-module__wrapper--VW","popup":"CopyIconButton-module__popup--TA","button":"CopyIconButton-module__button--Wu"};